module.exports = __webpack_public_path__ + "static/media/goPrevious.de9e5e46.svg";